import FileIcon from "@mui/icons-material/InsertDriveFile";
import DeleteIcon from "@mui/icons-material/RemoveCircleOutline";
import SendIcon from "@mui/icons-material/Send";
import {
  Box,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemSecondaryAction,
  ListItemText,
  TextField,
} from "@mui/material";
import DOMPurify from "dompurify";
import { Field, Form, Formik } from "formik";
import { addNewMessageThunk } from "@/modules/ticket/ticketDetail/messages/messageListOperations";
import { useAppDispatch } from "@/store/store";
import { fetchMessagesByTicketIdThunk } from "../../modules/ticket/ticketDetail/messages/messageListOperations";
import { FileInput } from "./FileInput";

const sanitizeConf = {
  ALLOWED_TAGS: ["b", "br", "i", "em", "strong", "a", "p", "h1"],
  ALLOWED_ATTR: ["href"],
};

// Our inner form component which receives our form's state and updater methods as props
const TicketsChatForm = (props) => {
  const dispatch = useAppDispatch();
  const { itemId } = props;

  const initialValues = {
    content: "",
    files: [],
  };

  const handleSubmit = (values, { setSubmitting, setErrors, resetForm }) => {
    // Set form to submitting
    setSubmitting(true);

    const tempContent = values.content.split("\n").join("<br>");
    values.content = DOMPurify.sanitize(tempContent, sanitizeConf);

    const message = {
      id: itemId,
      content: values.content,
      attachments: values.files,
    };

    dispatch(addNewMessageThunk(message))
      .then(() => {
        // reload message list
        dispatch(fetchMessagesByTicketIdThunk(itemId));
        resetForm();
        setSubmitting(false);
      })
      .catch((err) => {
        setSubmitting(false);
        setErrors(err.message);
      });
  };

  return (
    <Formik initialValues={initialValues} onSubmit={handleSubmit}>
      {({ values, handleChange, isSubmitting, setValues }) => {
        const handleFileInputChange = (fileList) => {
          // manually set the list of attachments for formik
          setValues({ ...values, files: fileList });
        };

        const handleFileRemove = (id) => {
          const sanitizedFiles = values.files.filter(
            (file) => !(id === file.id),
          );
          // manually set the list of attachments for formik
          setValues({ ...values, files: sanitizedFiles });
        };

        const hasFiles = values.files && values.files.length > 0;

        return (
          <div>
            {hasFiles && (
              <List dense={true}>
                {values.files.map((file) => (
                  <ListItem key={file.id}>
                    <ListItemIcon>
                      <FileIcon />
                    </ListItemIcon>
                    <ListItemText>{file.name}</ListItemText>
                    <ListItemSecondaryAction>
                      <IconButton onClick={() => handleFileRemove(file.id)}>
                        <DeleteIcon />
                      </IconButton>
                    </ListItemSecondaryAction>
                  </ListItem>
                ))}
              </List>
            )}

            <Box
              component={Form}
              sx={{ display: "flex", alignItems: "center" }}
            >
              <Field name="content">
                {({ field }) => (
                  <TextField
                    {...field}
                    disabled={isSubmitting}
                    placeholder="Mitteilung schreiben ..."
                    multiline
                    sx={{ flexGrow: 1 }}
                  />
                )}
              </Field>

              <FileInput color="primary" onChange={handleFileInputChange} />

              <Divider sx={{ width: "1px", height: 28, m: 0.5 }} />
              <IconButton
                color="primary"
                aria-label="Send"
                type="submit"
                disabled={isSubmitting}
              >
                <SendIcon />
              </IconButton>
            </Box>
          </div>
        );
      }}
    </Formik>
  );
};

export default TicketsChatForm;
